module.exports = __webpack_public_path__ + "static/media/apartment.42b4cd6b.png";